
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "./navbar";
import Sidebar from "./sidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import { SkipToContent } from "./accessibility";
import ErrorBoundary from "./ErrorBoundary";
import { toast } from "@/hooks/use-toast";
import { logError } from "@/utils/logger";
import { captureError } from "@/utils/monitoringService";

const Layout = () => {
  const isMobile = useIsMobile();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(prev => !prev);
  };

  const handleMainContentError = (error: Error, errorInfo: React.ErrorInfo) => {
    logError("Main content error", "Layout", {
      error: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack
    });
    
    captureError(error, {
      component: "MainContent",
      errorInfo: errorInfo.componentStack
    });
    
    toast({
      title: "Application Error",
      description: "An error occurred in the application. Our team has been notified.",
      variant: "destructive",
    });
  };

  return (
    <div className="flex h-screen overflow-hidden">
      <SkipToContent />
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
      <div className="flex flex-col flex-1 overflow-hidden">
        <Navbar toggleSidebar={toggleSidebar} />
        <main id="main-content" className="flex-1 overflow-y-auto p-4">
          <ErrorBoundary 
            component="MainContentArea"
            fallback={
              <div className="p-4 rounded-md bg-red-50 border border-red-200">
                <p className="text-red-800">Something went wrong in the main content area.</p>
              </div>
            }
            onReset={() => window.location.reload()}
          >
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
};

export default Layout;
